"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _release = require("@/api/doc/release");
var _validate = require("@/utils/validate");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'releaseInfo',
  data: function data() {
    return {
      form: {
        blNo: ''
      },
      releaseInfo: {
        blNo: undefined,
        releaseStatus: undefined,
        releaseDate: undefined
      },
      changeInfo: {
        blNo: undefined,
        deliveryReleaseFlag: undefined,
        deliveryReleaseDate: undefined
      },
      isResult: false,
      loading: false,
      rules: {
        blNo: [{
          required: true,
          message: this.$t('validate.blNo'),
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    toSearch: function toSearch() {
      var _this = this;
      this.$refs.form.validate(function (vaild) {
        if (vaild) {
          _this.loading = (0, _utils.load)();
          (0, _release.releaseSearch)(_this.form).then(function (response) {
            if (!(0, _validate.validateNull)(response.data.ReleaseStatusVO) && !(0, _validate.validateNull)(response.data.ReleaseStatusDoVO)) {
              _this.releaseInfo = response.data.ReleaseStatusVO;
              _this.changeInfo = response.data.ReleaseStatusDoVO;
              _this.isResult = true;
            } else {
              _this.releaseInfo = [];
              _this.changeInfo = [];
              _this.isResult = true;
            }
          }).catch(function () {
            _this.releaseInfo = [];
            _this.changeInfo = [];
            _this.isResult = false;
          }).finally(function () {
            _this.loading.close();
          });
        }
      });
    }
  }
};